
import { Vue, Component, Watch } from 'vue-property-decorator';
import { userDetail } from '../api/wap';
import { Swipe, SwipeItem } from 'vant';
import XGplayer from '@/components/XGplayer.vue';
Vue.use(Swipe);
Vue.use(SwipeItem);

@Component({
  components: {
    XGplayer,
  },
})
export default class UserDetails extends Vue {
  detailData: any = {};
  keyValue: any = [
    { key: 'title', label: '作品名称：' },
    { key: 'name', label: '作者：' },
    { key: 'contact', label: '联系方式：' },
    { key: 'teacher', label: '指导教师：' },
    { key: 'school', label: '所属院校：' },
    { key: 'class', label: '年级：' },
    { key: 'education', label: '学历：' },
    // { key: 'introduction', label: '简介：' },
  ];
  async mounted() {
    if (!window.udid) {
      return this.$router.push('home');
    }
    const res: any = await userDetail(this.$route.query.id as string);
    this.detailData = res.data;
    if (this.detailData.files) {
      this.detailData.files = JSON.parse(this.detailData.files);
    }

    if (this.detailData.explanation) {
      this.detailData.explanation = this.detailData.explanation;
    }
  }
  copy() {
    this.$toast.success('复制成功');
  }
}
